import { assign, balance, trimTail } from '../lib/array'
import createPredict from './prediction/options'

export const MIN = 2
export const MAX = 5

export function trim(val) {
	return (val || '').trim()
}

export function isEmpty(val) {
	return trim(val).length === 0
}

export default class OptionsService {
	constructor(options = [], predictions = [], history = []) {
		this.set(options, predictions)
		this.setPredict(history)
		this.update(options, predictions)
	}

	change(index, value) {
		let predictions = this.predictions.slice()
		if (index === 0) {
			const nextPredictions = this.predict(value)
			if (nextPredictions.length) {
				predictions = ['', ...nextPredictions]
			}
		}
		if (!value.length) {
			predictions[index] = ''
		}

		const options = this.options.map((option, i) => (
			i === index ? value : option
		))
		const merged = assign(options, predictions)

		if (merged.length >= MIN) {
			trimTail(merged, MIN)
			if (merged.length < MAX && !isEmpty(merged[merged.length - 1])) {
				merged.push('')
			}
		}

		balance(merged.length, options)

		return this.set(options, predictions)
	}

	set(options, predictions) {
		return Object.assign(this, { options, predictions })
	}

	setPredict(history = []) {
		this.predict = createPredict(history)
	}

	update(options = [], predictions = []) {
		const no = Math.max(predictions.length, options.length, MIN - 1) + 1

		return this.set(
			assign([...Array(no)].map((v, i) => options[i]), this.options),
			[...Array(no)].map((v, i) => predictions[i])
		)
	}
}



// WEBPACK FOOTER //
// ./src/services/OptionsService.js